/**
 * Threshold Price Updater
 * Finds elements with js-threshold-price attribute and replaces [threshold_price] placeholder
 * with the converted price based on current market currency rate
 */
class ThresholdPriceUpdater {
	constructor() {
		this.init();
	}

	init() {
		// Process immediately if DOM is ready
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => this.updatePrices());
		} else {
			this.updatePrices();
		}

		// Listen for currency changes
		document.addEventListener('currency:changed', () => this.updatePrices());
	}

	updatePrices() {
		const elements = document.querySelectorAll('[js-threshold-price]');
		elements.forEach(element => this.updateElement(element));
	}

	updateElement(element) {
		const basePrice = parseFloat(element.getAttribute('js-threshold-price'));
		if (isNaN(basePrice)) return;

		// Use existing currency rate system
		const rate = Number(window.Shopify?.currency?.rate) || 1;
		// Convert to main currency units first, then round up to ensure we get a whole number
		const convertedPrice = Math.ceil((basePrice * rate) / 100);
		const formattedPrice = this.formatPrice(convertedPrice);
		this.replaceThresholdPrices(element, formattedPrice);
	}

	formatPrice(wholeAmount) {
		// Use existing currency symbol from cart threshold or Shopify
		const symbol = window.cartThreshold?.currencySymbol || 
					   window.Shopify?.currency?.symbol || 
					   '$';
		// wholeAmount is already a whole number, no need to divide by 100
		const currency = window.Shopify?.currency?.active;
		return currency ? `${symbol}${wholeAmount} ${currency}` : `${symbol}${wholeAmount}`;
	}

	replaceThresholdPrices(element, formattedPrice) {
		// Find all threshold price elements within the element
		const thresholdElements = element.querySelectorAll('[js-threshold-price-element]');
		
		thresholdElements.forEach(thresholdEl => {
			// Add a minimal delay for smoother transition
			setTimeout(() => {
				// Set the formatted price as content
				thresholdEl.textContent = formattedPrice;
				// Remove loading class from the element with smooth transition
				thresholdEl.classList.remove('threshold-price-loading');
			}, 50); // Minimal delay
		});

		// Fallback: if no elements found, search in text nodes (backward compatibility)
		if (thresholdElements.length === 0) {
			this.replaceTextContent(element, formattedPrice);
			element.classList.remove('threshold-price-loading');
		}
	}

	replaceTextContent(element, formattedPrice) {
		// Use TreeWalker for efficient text node traversal
		const walker = document.createTreeWalker(
			element,
			NodeFilter.SHOW_TEXT,
			null,
			false
		);

		const textNodes = [];
		let node;
		
		while (node = walker.nextNode()) {
			if (node.textContent.includes('[threshold_price]')) {
				textNodes.push(node);
			}
		}

		textNodes.forEach(textNode => {
			textNode.textContent = textNode.textContent.replace(
				/\[threshold_price\]/g, 
				formattedPrice
			);
		});
	}

	// Static method for manual updates
	static updateAllPrices() {
		new ThresholdPriceUpdater().updatePrices();
	}
}

// Auto-initialize
new ThresholdPriceUpdater();

// Expose globally
window.ThresholdPriceUpdater = ThresholdPriceUpdater;
